module.exports = __webpack_public_path__ + "img/msu3-4.237186bf.png";